import React from "react";

export default function InputData2(){
    return(
        <div className="flex flex-col w-full px-10 items-center justify-center pt-20 pb-10">
            <div className="text-4xl font-medium text-center">
            Tambah Data Bahan Baku
            </div>
            <div className="text-sm text-center">
            Perencanaan menu agar dapur dapat menjaga konsistensi dan efisiensi dalam penyediaan makanan, serta meminimalisir potensi kekurangan atau kelebihan bahan.
            </div>
        </div>

    )
}